import { ENV } from '@/env';

function required(name: string): string {
    const value = ENV[name];
    if (!value) {
        throw new Error(
            `${name} is not set. Locally: create public/config.js (see README). Heroku: set the config var.`,
        );
    }
    return value;
}

/** One base URL per backend. A future dispo backend is one more key here (spec §7.3). */
export const backends = {
    core: required('APP_BACKEND_URL'),
} as const;

export type Backend = (typeof backends)[keyof typeof backends];
